import React, { FC, memo } from 'react'
import { tokens } from '@getgo/chameleon-core/next/goto-admin'
import { Box, LinearProgress, makeStyles, Slide } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  frontBar: {
    backgroundColor: tokens.surfaceColorBrandDefault,
  },
  linearProgressBox: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
  },
}))

const TopPageLoader: FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.linearProgressBox}>
      <Slide in direction="down">
        <LinearProgress classes={{ barColorPrimary: classes.frontBar }} />
      </Slide>
    </Box>
  )
}

export default memo(TopPageLoader)
